import { createSlice } from "@reduxjs/toolkit";

const ModalSlice = createSlice({
    name: "modal",
    initialState: {
        isSucessModal: {
            open: false,
            msg: ""
        },
        isShareMixOnSave: false,
        isOpenSaveMixModal: false,
        isOpenShareMixModal: false,
        isOpenCreatePlaylistModal: false,
        isOpenEditPlaylistModal: false,
        isOpenRemovePlaylistModal: false,
        isOpenPlaylistTray: false
    },
    reducers: {
        handleSuccessModal(state, action) {
            state.isSucessModal = action.payload;
        },
        handleSaveMixModal(state, action) {
            state.isOpenSaveMixModal = action.payload;
        },
        handleShareMixModal(state, action) {
            state.isOpenShareMixModal = action.payload;
        },
        handleShareMixOnSave(state, action) {
            state.isShareMixOnSave = action.payload;
        },
        handleCreatePlaylistModal(state, action) {
            console.log("Hit ---")
            state.isOpenCreatePlaylistModal = action.payload;
        },
        handleEditPlaylistModal(state, action) {
            state.isOpenEditPlaylistModal = action.payload;
        },
        handleRemovePlaylistModal(state, action) {
            state.isOpenRemovePlaylistModal = action.payload;
        },
        handlePlaylistTray(state, action) {
            state.isOpenPlaylistTray = action.payload;
        },
    },
});

export const { handleSuccessModal, handleSaveMixModal, handleShareMixModal, handleShareMixOnSave, handleCreatePlaylistModal, handleEditPlaylistModal, handleRemovePlaylistModal, handlePlaylistTray } = ModalSlice.actions;

export default ModalSlice.reducer;
